/* global fbq */

import React, { useState, useEffect, useRef, Fragment } from 'react';

import PremiumSelect from '../../components/PremiumSelect';
import { Snackbar, Alert } from '@mui/material';
import RoleSelector from '../../components/RoleSelectorCoaching';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';

import { Helmet } from 'react-helmet-async';
import OG from '../../assets/og/versus.png';

const RANKS = [
  'Master', 'Grandmaster'
];

const USER_RANKS = [
  'Unranked', 'Iron', 'Bronze', 'Silver', 'Gold', 'Platinum', 'Emerald', 'Diamond', 'Master', 'Grandmaster', 'Challenger'
];


const rawChamps = require('../../constants/champions.json');
const champions = Array.isArray(rawChamps) ? rawChamps : Object.values(rawChamps);

export default function VersusCoaching({ updatePrice, order_details, checkoutInit, loading }) {
    const { getAccessToken } = useAuth();
  
    const currency = localStorage.getItem('currency') || 'USD';

    const [coachRank, setCoachRank] = useState(RANKS[1]);
    const [usersRank, setUsersRank] = useState(USER_RANKS[4]);
    const [searchChamp, setSearchChamp] = useState('');
    const [selectedChamps, setSelectedChamps] = useState([]);
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [region, setRegion] = useState('NA');
    const [language, setLanguage] = useState('English');
    const [battleHours, setBattleHours] = useState(1);

    const [snackbar, setSnackbar] = useState({ open: false, severity: 'success', message: '' });
    const [initialLoad, setInitialLoad] = useState(true);

    // Initial load timer
    useEffect(() => {
        const timer = setTimeout(() => setInitialLoad(false), 500);
        return () => clearTimeout(timer);
    }, []);

    // Load stored data or calculate on mount
    useEffect(() => {
        const stored = localStorage.getItem('mixed-coaching-data');
        if (stored) {
            const parsed = JSON.parse(stored);
            setCoachRank(parsed.coachRank || RANKS[1]);
            setBattleHours(parsed.battleHours || 1);
            setLanguage(parsed.language || 'English');
            //allowed regions NA, LAN, LAS, EUW
            if (parsed.region && ['NA', 'LAN', 'LAS', 'EUW'].includes(parsed.region)) {
                setRegion(parsed.region || 'NA');
            } else {
                setRegion('NA');
            }
            setSelectedChamps(parsed.champions || []);
            setSelectedRoles(parsed.roles || []);
            setUsersRank(parsed.usersRank || USER_RANKS[4]);
            setSelectedRoles(parsed.selectedRoles || []);
            setSelectedChamps(parsed.selectedChamps || []);
            calculatePrice();
            order_details([
                ['Coach Type', 'Battle Coaching'],
                ['Coach Rank', parsed.coachRank || RANKS[1]],
                ['Battle Hours', parsed.battleHours || 1],
                ['Language', parsed.language || 'English'],
            ]);
        } else {
            calculatePrice();
            order_details([
                ['Coach Type', 'Battle Coaching'],
                ['Coach Rank', RANKS[1]],
                ['Battle Hours', 1],
                ['Language', 'English'],
            ]);
        }
    }, []);

    // Recalculate on key state changes
    useEffect(() => {
        if(initialLoad) return;
        updateOrderDataCookie();
        calculatePrice();
    }, [coachRank, battleHours]);

    // Update order details on state changes
    useEffect(() => {
        if (initialLoad) return;
        updateOrderDataCookie();
    }, [selectedChamps, selectedRoles, usersRank, region, language]);

  const updateOrderDataCookie = () => {
    order_details([
        ['Coach Type', 'Battle Coaching'],
        ['Coach Rank', coachRank],
        ['Battle Hours', battleHours],
        ['Language', language],
    ]);
    
    let vodHours = 0;
    let copilotHours = 0;
    if (localStorage.getItem('mixed-coaching-data')) {
        const parsed = JSON.parse(localStorage.getItem('mixed-coaching-data'));
        vodHours = parsed.battleHours || 0;
        copilotHours = parsed.copilotHours || 0;
    }
    const data = { coachRank, vodHours, copilotHours, battleHours, language, region, selectedChamps, selectedRoles, usersRank };
    localStorage.setItem('mixed-coaching-data', JSON.stringify(data));
  }

    const calculatePrice = () => {
        loading(true);
        if(initialLoad) {
        //use the stored data to calculate the price
        const stored = localStorage.getItem('mixed-coaching-data');
        if (stored) {
            const parsed = JSON.parse(stored);
            axios.post(process.env.REACT_APP_API_URL +  '/price-calculation-coaching', { 
                coachRank: parsed.coachRank || RANKS[1],
                copilotHours: 0,
                vodHours: 0,
                battleHours: parsed.battleHours || 1,
                currency
            }).then((response) => {
            loading(false);
            updatePrice(response.data.totalPrice);
            }).catch((error) => {
            setSnackbar({ open: true, severity: 'error', message: 'Failed to calculate price. Please try again.' });
            console.log(error);
            });
            return;
        }
        } 
        axios.post(process.env.REACT_APP_API_URL + '/price-calculation-coaching', {
            coachRank,
            copilotHours: 0,
            vodHours: 0,
            battleHours,
            currency
        }).then((response) => {
            loading(false);
            updatePrice(response.data.totalPrice);
            order_details([
                ['Coach Type', 'Battle Coaching'],
                ['Coach Rank', coachRank],
                ['Battle Hours', battleHours],
                ['Language', language],
            ]);
        }).catch((error) => {
            setSnackbar({ open: true, severity: 'error', message: 'Failed to calculate price. Please try again.' });
            console.log(error);
        });
    };

    
    const pushToDataLayer = (payload) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
    };

    //checkoutInit is passed, update the checkout state
    useEffect(() => {
        if (checkoutInit) {
          const data = {
            coach_rank: coachRank,
            users_rank: usersRank,
            copilot_hours: 0,
            vod_hours: 0,
            battle_hours: battleHours,
            server: region,
            roles: selectedRoles,
            champions: selectedChamps,
            language: language
          };
          if (typeof fbq !== 'undefined') {
            fbq('track', 'InitiateCheckout', {
              content_type: 'product',
              content_ids: ['versus'],
              content_name: 'Versus Coaching',
              currency: currency,
              value: checkoutInit.price,
              num_items: 1,
              contents: [
                {
                  id: 'versus',
                  quantity: 1,
                  item_price: checkoutInit.price
                }
              ]
            });
          }
          pushToDataLayer({
            event: 'begin_checkout',
            ecommerce: {
              value:    checkoutInit.price,
              currency: currency
            }
          })
          axios.post(process.env.REACT_APP_API_URL + `/user/stripe-checkout`, {
            order_type: 'coaching', 
            boost_type: 'Coaching', 
            server: region, 
            coupon: checkoutInit.coupon, 
            coaching: data,
            currency: currency
        }, {
            headers: {
                Authorization: getAccessToken()
            }
        }).then((response) => {
            window.location.href = response.data.url;
        }).catch((error) => {
            console.log(error);
        });
        }
    }, [checkoutInit]);

    const handleClose = () => {
        setSnackbar(s => ({ ...s, open: false }));
    };
    
    const toggleRole = key => {
        setSelectedRoles(prev =>
        prev.includes(key) ? prev.filter(r => r !== key) : [...prev, key]
        );
    };

    const toggleChamp = name => setSelectedChamps(prev => prev.includes(name) ? prev.filter(c => c !== name) : [...prev, name]);

    const filtered = champions.filter(c => c.toLowerCase().includes(searchChamp.toLowerCase()));

  return (
    <>  
      <Helmet>
        <meta charSet="utf-8" />
        <title>LoL Versus Coaching – 1v1 Duels with a Pro | EloFactory.gg</title>
        <meta
          name="description"
          content="Challenge a pro coach in 1v1 ranked duels. Test your skills head-to-head and receive live commentary on your strengths and areas to improve."
        />
        <link rel="canonical" href="https://elofactory.gg/get-coaching/versus" />

        {/* Open Graph */}
        <meta property="og:type"        content="website" />
        <meta property="og:title"       content="LoL Versus Coaching – 1v1 Duels with a Pro" />
        <meta property="og:description" content="Face off against a Challenger-rank coach in live 1v1 matches. Get direct feedback on your decision-making, mechanics, and matchups." />
        <meta property="og:url"         content="https://elofactory.gg/get-coaching/versus" />
        <meta property="og:image"       content={OG} />
        <meta property="og:image:width"  content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name"   content="EloFactory.gg" />

        {/* Twitter Card */}
        <meta name="twitter:card"        content="summary_large_image" />
        <meta name="twitter:title"       content="LoL Versus Coaching – 1v1 Duels with a Pro" />
        <meta name="twitter:description" content="Face off against a Challenger-rank coach in live 1v1 matches. Receive immediate feedback on decision-making, mechanics, and champion matchups." />
        <meta name="twitter:image"       content={OG} />
        <meta name="twitter:site"        content="@elofactorygg" />
        <meta name="twitter:creator"     content="@elofactorygg" />

        <meta name="robots" content="index, follow" />
        <link rel="alternate" hrefLang="en-US" href="https://elofactory.gg/get-coaching/versus" />

        {/* Structured Data */}
        <script type="application/ld+json">{`
        {
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "LoL Versus Coaching",
          "description": "Challenge a pro coach in live 1v1 duels and get direct feedback on your gameplay, mechanics, and champion matchups.",
          "provider": {
            "@type": "Organization",
            "name": "EloFactory",
            "url": "https://elofactory.gg"
          },
          "areaServed": "North America",
          "serviceType": "Versus Coaching",
          "url": "https://elofactory.gg/get-coaching/versus"
        }
        `}</script>
      </Helmet>

      {/* Rank Section */}
      <div
        className="
          rounded-lg bg-[var(--bg-surface)] border border-[var(--border)] p-6 text-white
          flex flex-col md:flex-row gap-8
        "
      >
        {/* Coach Rank */}
        <div className="flex-1 md:border-r md:border-[var(--border)] md:pr-6">
          <h2 className="mb-4 text-lg font-semibold text-[#00baff]">Coach Rank</h2>
          <div className="flex items-start gap-4 ">
            <img
              id="coachEmblem"
              src={require(`../../assets/Emblems/${coachRank}_Emblem.png`)}
              alt={`${coachRank} Rank Icon`}
              title={`League of Legends ${coachRank} Ranked Icon`}
              className="h-28 w-28 object-contain"
              width={112}    // 28 * 4px = 112px
              height={112}
            />
            <div className="flex w-full flex-col gap-3">
              <PremiumSelect
                value={coachRank}
                onChange={setCoachRank}
                options={RANKS}
                label="Rank"
              />
              <PremiumSelect
                  label="Battle Hours"
                  value={battleHours}
                  onChange={setBattleHours}
                  options={[0, 1, 2, 3]}
                  labelTooltipText="Select the number of hours you want to battle against your coach."
              />
            </div>
          </div>
        </div>

        {/* Users Rank */}
        <div className="flex-1">
          <h2 className="mb-4 text-lg font-semibold text-[#00baff]">Your Rank</h2>
          <div className="flex items-start gap-4">
            <img
              id="usersEmblem"
              src={require(`../../assets/Emblems/${usersRank}_Emblem.png`)}
              alt={`${usersRank} Rank Icon`}
              title={`League of Legends ${usersRank} Ranked Icon`}
              className="h-28 w-28 object-contain"
              width={112}    // 28 * 4px = 112px
              height={112}
            />
            <div className="flex w-full flex-col gap-3">
                <PremiumSelect
                    value={usersRank}
                    onChange={setUsersRank}
                    options={USER_RANKS}
                    label="Rank (Optional)"
                    labelTooltipText="Select your current or peak rank."
                />
                <RoleSelector
                  selectedRoles={selectedRoles}
                  toggleRole={toggleRole}
                />
            </div>
          </div>
        </div>
      </div>

      {/* Region & Language */}
      <div className="rounded-lg bg-[var(--bg-surface)] border border-[var(--border)] p-6 text-white">
          <h2 className="mb-4 text-lg font-semibold text-[#00baff]">Region & Language</h2>
          <div className="flex flex-wrap gap-4">
            <div className="min-w-[200px] flex-1">
                <PremiumSelect
                label="Account Region"
                value={region}
                onChange={setRegion}
                options={['NA', 'EUW', 'EUNE', 'LAN']}
                labelTooltipText="Select your account region."
                />
            </div>
            <div className="min-w-[200px] flex-1">
              <PremiumSelect
                label="Language"
                value={language}
                onChange={setLanguage}
                options={['English', 'Spanish']}
              />
            </div>
          </div>
      </div>

      {/* Champion Selector */}
      <div className="rounded-lg bg-[var(--bg-surface)] border border-[var(--border)] p-6 text-white flex flex-col">
        <h2 className="mb-4 text-lg font-semibold text-[#00baff]">Champion Selector</h2>
        <div className={`space-y-2`}>
        
        {/* ─── Search box (unstyled, just your original class) ─── */}
        <input
          type="text"
          placeholder="Search champions…"
          value={searchChamp}
          onChange={e => setSearchChamp(e.target.value)}
          className="search-input w-full rounded-md bg-[var(--bg-surface)] border border-[var(--border)] px-3 py-2 text-sm text-white placeholder-[var(--secondary-text)] focus:outline-none focus:ring-1 focus:ring-[var(--focus-ring)]"
        />

        {/* ─── Champions container: grid when enabled, .is-disabled when off ─── */}
        <div
          className={`
            champions-container
            scrollbar-custom
            h-52
            grid grid-cols-2 
            sm:grid-cols-3 lg:grid-cols-4 gap-2 overflow-y-auto max-h-64 rounded-md bg-[var(--bg-surface)] 
            border border-[var(--border)]
          `}
        >
          {filtered.map(champ => (
            <label key={champ} className="champion-item flex items-center p-1 rounded">
              <input
                type="checkbox"
                checked={selectedChamps.includes(champ)}
                onChange={() => {
                  //champion selection maximum of 10
                  if (selectedChamps.length >= 10 && !selectedChamps.includes(champ)) {
                    setSnackbar({ open: true, severity: 'warning', message: 'You can only select up to 10 champions.' });
                    return;
                  }
                  toggleChamp(champ)
                }}
              />
              <span className="champion-name">{champ}</span>
            </label>
          ))}
        </div>

        </div>
      </div>
      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={handleClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}